var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.831,
    height: 27.441,
    viewBox: "0 0 20.831 27.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document-signed",
    d: "M21.217,3.44,19.393,1.613A5.473,5.473,0,0,0,15.5,0H8.509A5.515,5.515,0,0,0,3,5.509V20.933a5.515,5.515,0,0,0,5.509,5.509h8.814a5.515,5.515,0,0,0,5.509-5.509V7.334A5.473,5.473,0,0,0,21.217,3.44ZM19.659,5a3.23,3.23,0,0,1,.418.511H17.322V2.754a3.415,3.415,0,0,1,.512.419Zm.968,15.935a3.305,3.305,0,0,1-3.305,3.305H8.509A3.305,3.305,0,0,1,5.2,20.933V5.509A3.305,3.305,0,0,1,8.509,2.2h6.61V5.509a2.2,2.2,0,0,0,2.2,2.2h3.305ZM17.322,9.916a1.1,1.1,0,0,1,0,2.2H8.509a1.1,1.1,0,1,1,0-2.2Zm1.1,5.509a1.1,1.1,0,0,1-1.1,1.1H8.509a1.1,1.1,0,1,1,0-2.2h8.814A1.1,1.1,0,0,1,18.424,15.424Zm-.212,3.76a1.1,1.1,0,0,1-.239,1.536,7.122,7.122,0,0,1-3.808,1.314,3.583,3.583,0,0,1-2.2-.771c-.361-.248-.5-.331-.771-.331a4.353,4.353,0,0,0-2.018.875,1.1,1.1,0,0,1-1.337-1.75,6.457,6.457,0,0,1,3.36-1.329,3.333,3.333,0,0,1,2.018.722,1.484,1.484,0,0,0,.952.38,5.053,5.053,0,0,0,2.509-.891,1.1,1.1,0,0,1,1.538.245Z",
    transform: "translate(-2.5 0.5)",
    stroke: "#fff",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.588a213033eb317cbda80d69cd506679.svg";
export { ForwardRef as ReactComponent };